/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Card_SessionInputs */



/**
* | output |
* | --- |
* | "Opened the form to add a card" |
*
* @param {Activity_Card_SessionInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_card_session = /** @type {((inputs?: Activity_Card_SessionInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Card_SessionInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыта форма добавления карты")
	return /** @type {LocalizedString} */ ("Opened the form to add a card")
});